import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom/cjs/react-router-dom'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import LockIcon from '@material-ui/icons/Lock'
import { useUpgradeDialog } from 'contexts/UpgradeDialogContext'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { CLUB_SUBSCRIPTION_ROUTE } from 'constants/routes'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    margin: 'auto',
    maxWidth: 600,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    '& .MuiListItemIcon-root': {
      minWidth: 40,
    },
    boxShadow: `0px 0px 10px ${theme.palette.grey[300]}`,
  },
  checkList: {
    '& .MuiTypography-body1': {
      fontSize: 12,
    },
  },
}))

const UpgradeMembershipInfo = ({
  history,
  fontSize,
  team,
}) => {
  const classes = useStyles()
  const { hideUpgradeDialog } = useUpgradeDialog()

  const handleUpgradeClick = () => {
    // Hide the upgrade dialog
    hideUpgradeDialog()

    history.push(
      CLUB_SUBSCRIPTION_ROUTE.populateURLParams({
        clubUuid: team.club_uuid,
      })
    )
  }

  return (
    <Box
      className={classes.root}
      {...(fontSize === 'small' && { style: { maxWidth: 500 } })}
    >
      <Box textAlign="center">
        <Box>
          <LockIcon
            {...(fontSize === 'small'
              ? { style: { width: 20, height: 20 } }
              : { style: { width: 40, height: 40 } })}
            color="primary"
          />
        </Box>
        <Box my={2}>
          <Typography variant={fontSize === 'small' ? 'h3' : 'h1'}>
            <Translate id="plans.upgrade-alert.title" />
          </Typography>
        </Box>
        <Box my={2}>
          <Typography variant={fontSize === 'small' ? 'caption' : 'subtitle2'}>
            <Translate id="plans.upgrade-alert.sub-title" />
          </Typography>
        </Box>
      </Box>
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <List className={fontSize === 'small' && classes.checkList}>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={<Translate id="plans.upgrade-alert.feature1" />}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={<Translate id="plans.upgrade-alert.feature2" />}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={<Translate id="plans.upgrade-alert.feature3" />}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={<Translate id="plans.upgrade-alert.feature4" />}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={<Translate id="plans.upgrade-alert.feature5" />}
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpgradeClick}
          fullWidth
        >
          <Translate id="button.upgrade" />
        </Button>
      </Box>
    </Box>
  )
}

UpgradeMembershipInfo.defaultProps = {
  fontSize: 'normal',
}

UpgradeMembershipInfo.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  fontSize: PropTypes.string,
  team: PropTypes.shape({
    type: PropTypes.string.isRequired,
    club_uuid: PropTypes.string.isRequired,
  }).isRequired,
}

export default compose(
  withRouter,
  connect(({ team }) => ({
    team,
  }))
)(UpgradeMembershipInfo)
